import { AuthType, getErrorAsString } from '@notes/webintegrations-common'
import { Errors } from '../logger/Errors'
import { Log } from '../logger/Log'

export type SetTokenCase = 'refresh' | 'initialSetToken'

export class SetTokenInSdkActivity {
  private start: number
  private authType: AuthType
  private setTokenCase: SetTokenCase

  constructor(authType: AuthType, setTokenCase: SetTokenCase) {
    this.start = Date.now()
    this.authType = authType
    this.setTokenCase = setTokenCase
  }

  public finishWithSuccess(): void {
    Log.logger.logReportData('SetTokenInSdkActivity', false /* isCriticalEvent */, {
      'Success': true,
      'SuccessRate': 1,
      'Duration': Date.now() - this.start,
    } /* payloadNonPII */,  {
      'AuthType': this.authType,
      'SetTokenCase': this.setTokenCase,
    })
  }

  public finishWithFailure(errorBucket: string, error?: Error): void {
    Log.logger.logReportData('SetTokenInSdkActivity', false /* isCriticalEvent */, {
      'Success': false,
      'SuccessRate': 0,
      'Duration': Date.now() - this.start,
    } /* payloadNonPII */,  {
      'ErrorName': error ? error.name : '',
      'ErrorMessage': getErrorAsString(error),
      'ErrorBucket': errorBucket,
      'AuthType': this.authType,
      'SetTokenCase': this.setTokenCase,
    })

    Log.logger.logUnexpected(Errors.getSetTokenInSdkError(errorBucket), errorBucket)
  }
}
